import React from 'react';
import '../less/calculator.less';

// left calculator parts
import PawnshopCalcLeft from './leftPart/pawnshopCalc';
import QuickCashCalcLeft from './leftPart/quickCashCalc';
import SalaryCalcLeft from './leftPart/salaryCalc';
import InstallmentCalcLeft from './leftPart/installmentCalc';
import PayByPartsCalcLeft from './leftPart/payByPartsCalc';
import InstantInstallmentCalcLeft from './leftPart/instantInstallmentCalc';
import NewInstallmentCalcLeft from './leftPart/newInstallmentCalc';
import CreditCardsLeft from './leftPart/creditCards';
import AExpressLeft from './leftPart/aexpressCalc';
import CredlineLeft from './leftPart/credlineCalc';
import CreditCalcLeft from './leftPart/creditCalc';
import InstallmentFromStatementLeft from './leftPart/installmentFromStatementCalc';
import InstallmentFromStatementLeftNew from './leftPart/installmentFromStatementCalc-new';
import VygodaInstallmentLeft from './leftPart/vygodaInstallmentCalc';
import MoneyAutoLeft from './leftPart/moneyAutoCalc';

// right calculator parts
import PawnshopCalcRight from './rightPart/pawnshopCalc';
import QuickCashCalcRight from './rightPart/quickCashCalc';
import SalaryCalcRight from './rightPart/salaryCalc';
import InstallmentCalcRight from './rightPart/installmentCalc';
import PayByPartsCalcRight from './rightPart/payByPartsCalc';
import InstantInstallmentCalcRight from './rightPart/instantInstallmentCalc';
import NewInstallmentCalcRight from './rightPart/newInstallmentCalc';
import CreditCardsRight from './rightPart/creditCards';
import AxpressRight from './rightPart/aexpressCalc';
import CredlineRight from './rightPart/credlineCalc';
import CreditCalcRight from './rightPart/creditCalc';
import InstallmentFromStatementRight from './rightPart/installmentFromStatementCalc';
import InstallmentFromStatementRightNew from './rightPart/installmentFromStatementCalc-new';
import VygodaInstallmentRight from './rightPart/vygodaInstallmentCalc';
import expressEnergy from "../../../pages/SpecialOffers/ExpressEnergy";
import MoneyAutoRight from './rightPart/moneyAutoCalc';



export default function template() {
    const type = this.props.type,
        gold = 'gold',
        silver = 'silver',
        standard = 'standard',
        loyal = 'loyal',
        salary = 'salary',
        installment = 'installment',
        newInstallment = 'new_installment_plan',
        payByParts = 'payment_part',
        defaultInstantInstallment = 'default_instant_installment',
        creditCards = 'credit_cards',
        aexpress = 'aexpress',
        credline = 'credline',
        credit = 'credit',
        installment_from_statement = 'installment_from_statement',
        installment_from_statement_new = 'installment_from_statement_new',
        vygodaInstallment = 'credit_vygoda',
        expressEnergy = 'express-energy',
        money_auto = 'money_auto',
        leftPart = {
            [gold]: <PawnshopCalcLeft calc={this} />,
            [silver]: <PawnshopCalcLeft calc={this} />,
            [standard]: <QuickCashCalcLeft calc={this} />,
            [loyal]: <QuickCashCalcLeft calc={this} />,
            [salary]: <SalaryCalcLeft calc={this} />,
            [installment]: <InstallmentCalcLeft calc={this} />,
            [payByParts]: <PayByPartsCalcLeft calc={this} />,
            [defaultInstantInstallment]: <InstantInstallmentCalcLeft calc={this} />,
            [newInstallment]: <NewInstallmentCalcLeft calc={this} />,
            [creditCards]: <CreditCardsLeft calc={this} />,
            [aexpress]: <AExpressLeft calc={this} />,
            [expressEnergy]: <AExpressLeft calc={this} />,
            [credline]: <CredlineLeft calc={this} />,
            [credit]: <CreditCalcLeft calc={this} />,
            [installment_from_statement]: <InstallmentFromStatementLeft calc={this} />,
            [installment_from_statement_new]: <InstallmentFromStatementLeftNew calc={this} />,
            [vygodaInstallment]: <VygodaInstallmentLeft calc ={this} />,
            [money_auto]: <MoneyAutoLeft calc ={this} />
        },
        rightPart = {
            [gold]: <PawnshopCalcRight calc={this} type={type} />,
            [silver]: <PawnshopCalcRight calc={this} type={type} />,
            [standard]: <QuickCashCalcRight calc={this} type={type} />,
            [loyal]: <QuickCashCalcRight calc={this} type={type} />,
            [salary]: <SalaryCalcRight calc={this} />,
            [installment]: <InstallmentCalcRight calc={this} />,
            [payByParts]: <PayByPartsCalcRight calc={this} />,
            [defaultInstantInstallment]: <InstantInstallmentCalcRight calc={this} />,
            [newInstallment]: <NewInstallmentCalcRight calc={this} />,
            [creditCards]: <CreditCardsRight calc={this} cardType={this.props.cardType} />,
            [aexpress]: <AxpressRight calc={this} />,
            [expressEnergy]: <AxpressRight calc={this} />,
            [credline]: <CredlineRight calc={this} />,
            [credit]: <CreditCalcRight calc={this} />,
            [installment_from_statement]: <InstallmentFromStatementRight calc={this} />,
            [installment_from_statement_new]: <InstallmentFromStatementRightNew calc={this} />,
            [vygodaInstallment]: <VygodaInstallmentRight calc ={this} />,
            [money_auto]: <MoneyAutoRight calc ={this} />
        },
        orderBtn = this.props.isBtn
          ? (
            <button className="button-order"
                    onClick={this.props.toggleModal}>
              {this.l10n('EXPRESS_APPLICATION_APPLY_BTN')}
            </button>
          )
          : '';
    return (
        <div className={`calculator-body ${type}`}>
          <div className="calculator">
            <div className="left-part">{leftPart[type]}</div>
            <div className="right-part">{rightPart[type]}</div>
          </div>
          {orderBtn}
        </div>
    );
}
